(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-drawer')) {
    class ProductDescriptionDrawer extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          this.onReady = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.initialize();
        }
      }

      initialize() {
        if (!this.isConnected || !window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger = this.querySelector('[data-description-open]');
        if (!this.trigger) return;

        if (!this.dialog) {
          this.dialog = document.createElement('dialog');
          this.dialog.id = this.trigger.getAttribute('aria-controls');
          this.dialog.className = 'product-description-drawer';
          this.dialog.setAttribute('aria-labelledby', `${this.dialog.id}-Heading`);
          this.dialog.append(this.querySelector('[data-description-panel]'));
          this.append(this.dialog);
          this.querySelector('[data-description-fallback]').hidden = true;
          this.querySelector('[data-description-header]').hidden = false;
          this.trigger.hidden = false;
        }

        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('[data-description-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.restorePage();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.close();
          }
        }, options);
        this.addEventListener('shopify:block:select', () => this.open(), options);
        this.addEventListener('shopify:block:deselect', () => this.close(), options);
      }

      open() {
        if (this.dialog.open) return;
        this.scrollPosition = { x: window.scrollX, y: window.scrollY };
        this.dialog.showModal();
        const body = document.body;
        this.bodyStyles = ['position', 'top', 'left', 'width'].map((property) => [
          property, body.style.getPropertyValue(property), body.style.getPropertyPriority(property)
        ]);
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `${-this.scrollPosition.y}px`);
        body.style.setProperty('left', `${-this.scrollPosition.x}px`);
        body.style.setProperty('width', '100%');
        this.dialog.querySelector('h2').focus({ preventScroll: true });
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
        this.restorePage();
      }

      restorePage() {
        if (!this.bodyStyles) return;
        this.bodyStyles.forEach(([property, value, priority]) => {
          if (value) document.body.style.setProperty(property, value, priority);
          else document.body.style.removeProperty(property);
        });
        this.bodyStyles = null;
        window.scrollTo({ left: this.scrollPosition.x, top: this.scrollPosition.y, behavior: 'instant' });
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
        this.close();
        this.controller?.abort();
      }
    }
    customElements.define('product-description-drawer', ProductDescriptionDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["veora-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('veora-accordions')) {
  customElements.define('veora-accordions', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
      });
    }
  });
}
if (!customElements.get('veora-purchase')) {
  customElements.define('veora-purchase', class extends HTMLElement {
    connectedCallback() {
      this.variant = this.querySelector('[name="id"]');
      if (!this.variant) return;
      this.plans = this.querySelector('[name="selling_plan"]');
      this.submit = this.querySelector('[type="submit"]');
      this.update = (event) => {
        const option = this.variant.selectedOptions[0];
        const id = option.value;
        if (this.plans) {
          [...this.plans.options].forEach(plan => {
            const applies = !plan.value || plan.dataset.variant === id;
            plan.hidden = !applies;
            plan.disabled = !applies;
          });
          if (this.plans.selectedOptions[0]?.disabled) {
            const options = [...this.plans.options];
            const matching = options.findIndex(plan => !plan.disabled && plan.value === this.plans.value);
            this.plans.selectedIndex = matching >= 0 ? matching : options.findIndex(plan => !plan.disabled);
          }
          this.querySelector('[data-veora-plans]').hidden = ![...this.plans.options].some(plan => plan.value && !plan.disabled);
        }
        const selectedPlan = this.plans?.selectedOptions[0];
        const available = option.dataset.available === 'true' && (!this.plans?.required || Boolean(this.plans.value));
        this.submit.disabled = !available;
        this.submit.querySelector('[data-veora-submit-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.querySelector('[data-veora-price]').textContent = selectedPlan?.value ? selectedPlan.dataset.price : option.dataset.price;
        this.querySelector('[data-veora-stock]').textContent = option.dataset.available === 'true' ? this.dataset.inStock : this.dataset.soldLabel;
        const quantity = this.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min;
        quantity.step = option.dataset.step;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        if (!event || event.target === this.variant) quantity.value = option.dataset.min;
        const planNote = this.querySelector('[data-veora-plan-note]');
        if (planNote) planNote.textContent = selectedPlan?.dataset.description || '';
        document.querySelectorAll('[data-veora-sticky-price]').forEach(price => {
          price.textContent = this.querySelector('[data-veora-price]').textContent;
        });
      };
      this.variant.addEventListener('change', this.update);
      this.plans?.addEventListener('change', this.update);
      this.update();
    }
  });
}
if (!customElements.get('veora-sticky')) {
  customElements.define('veora-sticky', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.purchase = this.closest('section').querySelector('veora-purchase');
      this.button = this.querySelector('[data-veora-sticky-add]');
      this.add = () => {
        const submit = this.purchase?.querySelector('[type="submit"]');
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        submit.click();
        this.sync();
      };
      this.button?.addEventListener('click', this.add);
      this.showInvalid = () => this.purchase.scrollIntoView({ block: 'center' });
      this.purchase?.addEventListener('invalid', this.showInvalid, true);
      this.check = () => {
        this.sync();
        const hero = document.querySelector('[data-veora-hero-action]');
        const destination = document.querySelector('#veora-purchase');
        const blockers = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [data-veora-sticky-blocker], [aria-modal="true"], #chat-ui, #ShopifyChat[is-open]');
        const blocked = [...blockers].some(el => {
          if (el.closest('details:not([open])')) return false;
          if (el.checkVisibility?.({ checkOpacity: true, checkVisibilityCSS: true }) === false) return false;
          const rect = el.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth && getComputedStyle(el).visibility !== 'hidden';
        });
        const destinationRect = destination?.getBoundingClientRect();
        const atDestination = destinationRect && destinationRect.top < innerHeight && destinationRect.bottom > 0;
        const typing = ['INPUT', 'SELECT', 'TEXTAREA'].includes(document.activeElement?.tagName);
        const hidden = Boolean(!hero || hero.getBoundingClientRect().bottom > 0 || atDestination || blocked || typing);
        if (this.hidden !== hidden) this.hidden = hidden;
      };
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.check(); });
      };
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll);
      document.addEventListener('focusin', this.onScroll);
      document.addEventListener('focusout', this.onScroll);
      this.observer = new MutationObserver(this.onScroll);
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'disabled', 'aria-disabled', 'aria-hidden', 'aria-modal', 'class', 'style'] });
      this.check();
    }
    sync() {
      if (!this.button) return;
      const submit = this.purchase?.querySelector('[type="submit"]');
      if (!submit) { this.button.disabled = true; return; }
      const busy = submit.getAttribute('aria-disabled') === 'true';
      const disabled = submit.disabled || busy;
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
      if (this.button.getAttribute('aria-busy') !== String(busy)) this.button.setAttribute('aria-busy', String(busy));
      const label = this.querySelector('[data-veora-sticky-label]');
      const price = this.querySelector('[data-veora-sticky-price]');
      const nextLabel = submit.querySelector('[data-veora-submit-label]')?.textContent;
      const nextPrice = this.purchase.querySelector('[data-veora-price]')?.textContent;
      if (label && nextLabel && label.textContent !== nextLabel) label.textContent = nextLabel;
      if (price && nextPrice && price.textContent !== nextPrice) price.textContent = nextPrice;
      const error = this.purchase.querySelector('.product-form__error-message-wrapper');
      const errorText = error && !error.hidden ? error.textContent.trim() : '';
      if (errorText && errorText !== this.lastError) this.purchase.scrollIntoView({ block: 'center' });
      this.lastError = errorText;
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.add);
      this.purchase?.removeEventListener('invalid', this.showInvalid, true);
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      document.removeEventListener('focusin', this.onScroll);
      document.removeEventListener('focusout', this.onScroll);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
